export const MINUTE_IN_SECONDS = 60
export const HOUR_IN_SECONDS = 60 * MINUTE_IN_SECONDS
export const DAY_IN_SECONDS = 24 * HOUR_IN_SECONDS
export const MONTH_IN_SECONDS = 30 * DAY_IN_SECONDS
export const YEAR_IN_SECONDS = 365 * DAY_IN_SECONDS
